module.exports = __webpack_public_path__ + "img/Logo-NI-Preta.c7ac1f2b.png";